import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

// Barra de herramientas acotada a lo que Gmail ofrece en su compositor
// simple: formato de texto, listas, cita y enlaces. Nada de fuentes/colores
// exóticos que compliquen el HTML que después hay que sanitizar y enviar.
const MODULES = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'link'],
        ['clean'],
    ],
};

const FORMATS = ['bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'blockquote', 'link'];

export default function RichTextEditor({ value, onChange, placeholder }) {
    return (
        <div className="rich-text-editor rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden bg-white dark:bg-slate-800">
            <ReactQuill
                theme="snow"
                value={value}
                onChange={onChange}
                modules={MODULES}
                formats={FORMATS}
                placeholder={placeholder}
            />
            <style>{`
                .rich-text-editor .ql-toolbar { border: none; border-bottom: 1px solid rgba(148,163,184,0.25); }
                .rich-text-editor .ql-container { border: none; font-size: 0.875rem; }
                .rich-text-editor .ql-editor { min-height: 120px; max-height: 320px; overflow-y: auto; }
                .dark .rich-text-editor .ql-editor { color: #e2e8f0; }
                .dark .rich-text-editor .ql-snow .ql-stroke { stroke: #cbd5e1; }
                .dark .rich-text-editor .ql-snow .ql-fill { fill: #cbd5e1; }
                .dark .rich-text-editor .ql-snow .ql-picker { color: #cbd5e1; }
            `}</style>
        </div>
    );
}
